import axios from 'axios'
import { INVALID_TOKEN, ERROR_CODE, NOT_LOGIN, SUCCESS_CODE } from './httpCode'
import Vue from 'vue'
import Cookie from 'js-cookie'
import qs from 'qs'
import { AesDecrypt, SHA256Encrypt, AesEncrypt } from '@/js/utils'

import creditService from './creditService'

// import './mockData'

let isKoo = location.origin.includes('koofenqi.com')
let isLy = location.origin.includes('lyfortune.com')
let isTars = location.origin.includes('paifenle.com')

let APPID = ''
let TENANTID = ''

if (isKoo) {
    APPID = Cookie.get('appid')
    TENANTID = '5cf1baf1'

    if (!APPID || APPID === '1000002180') {
        APPID = '1000003198'
    }
}

if (isLy) {
    APPID = '1000003195'
    TENANTID = '2464d15a'
}

if (isTars) {
    APPID = Cookie.get('appid')
    TENANTID = 'c6788e2a'
}

function jumpToLogin() {
    if (isKoo) {
        location.href = `//ac.koofenqi.com/koo/login?redirect=${encodeURIComponent(
            location.href
        )}`
    } else if (isLy) {
        window.history.go(-1)
    } else if (isTars) {
        window.history.go(-1)
    } else {
        location.href = `//account.ppdai.com/h5/login?returnUrl=${encodeURIComponent(
            location.href
        )}`
    }
}



const _http = axios.create({
    baseURL: isKoo || isLy || isTars ? '' : '/api',
    timeout: 30000,
    headers:
        isKoo || isLy || isTars
            ? {
                // 'X-GW-TENANTID': isKoo ? '5cf1baf1' : '2464d15a',
                'X-GW-TENANTID': TENANTID,
                'X-GW-APPID': APPID,
                'X-GW-DEVICEID': Cookie.get('deviceid') || 'h5',
                'X-GW-TIMESTAMP': Date.now(),
                'X-GW-PLATFORM': Cookie.get('platform'),
                'X-GW-TOKEN': Cookie.get('token'),
            }
            : {},
})

let unEncryptedAll = ['/cash/credit/creditRepayRecordQuery'];
let unEncryptedReq = [].concat(unEncryptedAll);
let unDecryptedRes = ['/cash/credit/creditRepayCheck', '/cash/credit/setCreditCardInfo', '/cash/credit/addChargeCard', '/queryRecordNew', '/cash/credit/checkAuth'].concat(unEncryptedAll);

let encryptedAll = ['/cash/repay', '/cash/credit', '/cash/sign'];
let encryptedReq = ['/sendRecordNew', '/cash/credit/checkAuth'].concat(encryptedAll);
let encryptedRes = ['/validateTokenNew', '/cash/bind/ocrQueryStatusNew'].concat(encryptedAll);

// 需降级处理的接口，不做Toast报错提示
const DOWNGRADE_INTERFACES = ['/cash/repay/openAuthNew', '/cash/bind/ocrImgSave', '/cash/repay/queryAutoWithHolding', '/cash/pay/createPay'];


_http.interceptors.request.use(
    function (config) {
        // if ((config.url.includes('/cash/repay') || config.url.includes('/sendRecordNew') || config.url.includes('/cash/credit')) && !unEncryptedReq.includes(config.url)){
        if (encryptedReq.some(url => config.url.includes(url)) && !unEncryptedReq.some(url => config.url.includes(url))) {
            config.headers['X-XY-PAYCASH'] = SHA256Encrypt(config.data);

            config.data = {
                requestData: AesEncrypt(config.data)
            }
        }
        return config;
    },
    function (error) {
        return Promise.reject(error)
    }
)

_http.interceptors.response.use(
    function (response) {
        if (response.data.result === NOT_LOGIN) {
            jumpToLogin()
        }

        if (response.data.result === INVALID_TOKEN) {
            Vue.prototype.$bus.$vux.alert.show({
                title: '提示',
                content: '请求过期，请返回重试',
                onHide() {
                    // location.href = response.data.resultMessage
                },
            })
        }

        if (response.data.result === ERROR_CODE) {
            if (!DOWNGRADE_INTERFACES.includes(response.config.url)) {
                Vue.prototype.$bus.$vux.toast.show({
                    type: 'text',
                    text: response.data.resultMessage,
                    width: '50%',
                })
            }
        }
        // 完整性校验
        // if (response.data.result === SUCCESS_CODE 
        //     && response.data 
        //     && response.data.data
        //     && !response.config.url.includes('/queryRecordNew')
        //     && (response.config.url.includes('/cash/repay') || response.config.url.includes('/validateTokenNew'))){
        if (response.data.result === SUCCESS_CODE
            && response.data
            && response.data.data
            && encryptedRes.some(url => response.config.url.includes(url))
            && !unDecryptedRes.some(url => response.config.url.includes(url))) {
            let _data = response.data.data;
            let _hashData = _data['responseSign'];
            let _decryptedData = AesDecrypt(_data.responseData);
            let _encryptedData = SHA256Encrypt(_decryptedData);
            if (_hashData == _encryptedData) {
                response.data.data = JSON.parse(_decryptedData);
            } else {
                Vue.prototype.$bus.$vux.toast.show({
                    type: 'text',
                    text: '完整性校验失败，请重试',
                    width: '50%',
                })
            }
        }
        return response.data
    },
    function (error) {
        if (
            error.response &&
            error.response.headers &&
            ['GTW-BRQ-NOHEADER', 'GTW-BRQ-INVALIDTOKEN'].includes(
                error.response.headers['x-ppd-code']
            )
        ) {
            jumpToLogin()
        } else {
            if (!(error.response && error.response.config && DOWNGRADE_INTERFACES.includes(error.response.config.url))) {
                Vue.prototype.$bus.$vux.toast.show({
                    type: 'text',
                    text: '系统繁忙',
                    width: '50%',
                })
            }

            const responseStr = JSON.stringify(error.response)

            Sensors.track('h5_element_imp', {
                page: 'paycash页',
                tgt_event_id: 'h5_syt_998',
                tgt_name: `系统异常,responseStr:${responseStr},x-ppd-code:${error.response.headers['x-ppd-code']
                    },message:${error.response.data.Message}`,
                url: location.href,
            })
        }
        return Promise.reject(error)
    }
)

let _creditService = creditService(_http);

export default {
    test() {
        return _http.get('/test')
    },
    bindcardLoad(orderNum) {
        return _http.post('/cash/bind/load', { orderNum })
    },
    queryCardBin(params) {
        return _http.post('/cash/bind/queryCardBin', params)
    },
    sendSms(params) {
        return _http.post('/cash/bind/sendSms', params)
    },
    bindcardApply(params) {
        return _http.post('/cash/bind/apply', params)
    },
    validateToken(params) {
        return _http.post('/cash/common/validateTokenNew', params)
    },
    sendRecord(params) {
        return _http.post('/cash/common/sendRecordNew', params)
    },
    sendRecordNoToken(params) {
        return _http.post('/cash/notoken/sendRecord', params)
    },
    repayLoad(orderNum) {
        return _http.post('/cash/repay/repayLoadNew', { orderNum })
    },
    needChangeCard(params) {
        return _http.post('/cash/repay/needChangeCardNew', params)
    },
    organChangeCard(url, data) {
        // const formData = new FormData()
        // for (let key of Object.keys(data)) {
        //   formData.append(key, data[key])
        // }
        return _http.post(url, qs.stringify(data), {
            'Content-Type': 'application/x-www-form-urlencoded',
        })
    },
    repayNeedSms(params) {
        // return _http.post('/cash/repay/repayNeedSms', params)
        return _http.post('/cash/repay/repayNeedSmsNew', params)
    },
    repayQuery(params) {
        return _http.post('/cash/repay/repayQueryNew', params)
    },
    repaySendSms(params) {
        return _http.post('/cash/repay/repaySendSmsNew', params)
    },
    repayApply(params) {
        return _http.post('/cash/repay/repayApplyNew', params)
    },
    changeCard(params) {
        return _http.post('/cash/repay/changeCardNew', params)
    },
    unbind(params) {
        return _http.post('/cash/repay/unbindNew', params)
    },
    applyChangeMobile(params) {
        return _http.post('/cash/bind/applyChangeMobile', params)
    },
    confirmChangeMobile(params) {
        return _http.post('/cash/bind/confirmChangeMobile', params)
    },
    addCard(params) {
        return _http.post('/cash/repay/addCardNew', params)
    },
    queryCoupon(businessId) {
        // return _http.post(`/cash/repay/queryCouponNew?businessId=${businessId}`)
        return _http.post(`/cash/repay/queryCouponNew`, { businessId })
    },
    billSmsCheck(params) {
        return _http.post('/cash/repay/billSmsCheckNew', params)
    },
    offlineRepay(params) {
        return _http.post('/cash/repay/offlineRegisterNew', params)
    },
    confirmCredit(params) {
        return _http.post('/cash/repay/confirmCreditNew', params)
    },
    bookRepay(params) {
        return _http.post('/cash/repay/bookRepayNew', params)
    },
    createTwoDimensional(params) {
        return _http.post('/cash/repay/createTwoDimensionalNew', params)
    },
    shareUpload(params) {
        return _http.post('/cash/repay/shareNew', params)
    },
    wxScan(params) {
        return _http.post('/cash/notoken/wxScan', params)
    },
    openAuth(params) {
        return _http.post('/cash/repay/openAuthNew', params)
    },
    queryRecord(params) {
        return _http.post('/cash/repay/queryRecordNew', params)
    },
    getRetryUrl(params) {
        return _http.post('/cash/repay/retryUrlNew', params)
    },
    createGuideUrl(params) {
        return _http.post('/cash/repay/createGuideUrlNew', params)
    },
    changeMobileLoad(params) {
        return _http.post('/cash/bind/changeMobileLoad', params)
    },
    chargeLoad(params) {
        return _http.post('/cash/pay/chargeLoad', params)
    },
    createCharge(params) {
        return _http.post('/cash/pay/createPay', params)
    },
    chargeUnbind(params) {
        return _http.post('/cash/pay/unbind', params)
    },
    chargeChangeCard(params) {
        return _http.post('/cash/pay/changeCard', params)
    },
    chargeAddCard(params) {
        return _http.post('/cash/pay/addCard', params)
    },
    chargeQueryResult(params) {
        return _http.post('/cash/pay/queryResult', params)
    },
    getSecret() {
        return _http.get('/cash/bind/login')
    },
    ceBindcardLoad(orderNum) {
        return _http.post('/cash/bind/ceload', { orderNum })
    },
    ceApply(params) {
        return _http.post('/cash/bind/ceapply', params)
    },
    newCeapply(params) {
        return _http.post('/cash/bind/newCeapply', params)
    },
    cequeryQuickBindResult(params) {
        return _http.post('/cash/bind/cequeryQuickBindResult', params)
    },
    cequickBind(params) {
        return _http.post('/cash/bind/cequickBind', params)
    },
    cesendSms(params) {
        return _http.post('/cash/bind/cesendSms', params)
    },
    wechatSuccessCallBack(params) {
        return _http.post('/cash/repay/wechatSuccessCallBack', params)
    },
    ..._creditService,
    anyTimeApply(params) {
        return _http.post('/cash/repay/anyTimeApply', params)
    },
    anyTimeLoad() {
        return _http.post('/cash/repay/anyTimeLoadNew')
    },
    combineLoad(orderNum = "") {
        return _http.post('/cash/repay/combineLoad', { orderNum })
    },
    combineRepay(orderNum = "") {
        return _http.post('/cash/repay/combineRepay', { orderNum })
    },
    signLoad(params) {
        return _http.post('/cash/sign/load', params)
    },
    signApply(params) {
        return _http.post('/cash/sign/apply', params)
    },
    signConfirm(params) {
        return _http.post('/cash/sign/confirm', params)
    },
    bindConfirm(params) {
        return _http.post('/cash/bind/confirm', params)
    },
    repaySignConfirm(params) {
        return _http.post('/cash/repay/signConfirm', params)
    },
    queryAutoWithHold(params) {
        return _http.post('/cash/repay/queryAutoWithHold', params)
    },
    openAutoWithHold(params) {
        return _http.post('/cash/repay/openAutoWithHold', params)
    },
    drawCardSignResultLoad(params) {
        return _http.post('/cash/bind/drawCardSignResultLoad', params)
    },
    drawCardSignApply(params) {
        return _http.post('/cash/bind/drawCardSignApply', params)
    },
    openAlipayAutoWhold(params) {
        return _http.post('/cash/bind/openAlipayAutoWhold', params)
    },
    queryAlipayAutoWholdResult(params) {
        return _http.post('/cash/bind/queryAlipayAutoWholdResult', params)
    },
    queryBankDrawByLikeName(params) {
        return _http.post('/cash/bind/queryBankDrawByLikeName', params)
    },
    drawCardSignSure(params) {
        return _http.post('/cash/bind/drawCardSignSure', params)
    },
    queryDrawCardSignTrade(params) {
        return _http.post('/cash/bind/queryDrawCardSignTrade', params)
    },
    ocrImgSave(params) {
        return _http.post('/cash/bind/ocrImgSave', params)
    },
    ocrAsync(params) {
        return _http.post('/cash/bind/ocrAsync', params)
    },
    ocrQueryStatusNew(params) {
        return _http.post('/cash/bind/ocrQueryStatusNew', params)
    },
    queryAutoWithHolding(params) {
        return _http.post('/cash/repay/queryAutoWithHolding', params)
    },
    openAutoWithHolding(params) {
        return _http.post('/cash/repay/openAutoWithHolding', params)
    },
    openAlipayWithHolding(params) {
        return _http.post('/cash/repay/openAlipayWithHolding', params)
    },
    queryAlipayWithHolding(params) {
        return _http.post('/cash/repay/queryAlipayWithHolding', params)
    },
}
